import React from "react";
import './css/index.css';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import {Network} from "alchemy-sdk";

import Root from "./routes/root";
import ErrorPage from './routes/error-page';
import CypherMap from "./routes/cyphermap";
import Collection from "./routes/collection";
import MyCypherdudes from "./routes/my_cypherdudes";
import Cypherdude from "./routes/cypherdude";
import CypherdudeFS from "./routes/cypherdude_fullscreen";
import CypherPalace from "./routes/cypherpalace";
import Dos from "./routes/dos";
import WhiteList from "./routes/whitelist";
import About from "./routes/about";
import Admin from "./routes/admin";
import LeaderBoard from "./routes/leaderboard";
import Archives from "./routes/archives";
import ArchivesCollection from "./routes/archives_collection";
import Archive from "./routes/archive";
import Folder from "./routes/folder";
import WordsCloudFullScreen from "./routes/wordsCloudFullScreen";
import Artefacts from "./routes/artefacts";
import SatoshiMint from "./routes/satoshiMint";
import Tmp from "./routes/tmp";
import CypherPalaces from "./components/artefacts/CypherPalaces";
import CypherBoards from "./components/artefacts/CypherBoards";
import CypherPagers from "./components/artefacts/CypherPagers";
import DecentralizedOS from "./components/artefacts/DecentralizedOS";

import firebase from "./Firebase";

import {superAdminAddress} from './web3/adminAddresses';

import { useEffect, useState } from "react";
import { ethers } from "ethers";
import { createWeb3Modal, defaultConfig, useWeb3Modal, useWeb3ModalAccount, useWeb3ModalProvider } from "@web3modal/ethers/react";

const whitelistDB = firebase.firestore().collection('whitelist');
const bip39 = firebase.firestore().collection('bip39');

const alchemySettings = {
  apiKey : "uS4Hx1reTp_lNrzli7vz_QCCbQBDblhZ",
  network: Network.ETH_MAINNET,
}

function App() {
  const [superAdmin, setSuperAdmin] = useState(false);

  const projectId = process.env.REACT_APP_WEB3MODAL_PROJECT_ID;

  const { address, chainId, isConnected } = useWeb3ModalAccount();
  const { walletProvider } = useWeb3ModalProvider()
  const provider = new ethers.BrowserProvider(walletProvider);

  const mainnet = {
    chainId: 1,
    name: 'Ethereum',
    currency: 'ETH',
    explorerUrl: 'https://etherscan.io',
    // Keyed Infura endpoint — Web3Modal creates its own JsonRpcProvider from
    // this URL, so a dead endpoint here loops "failed to detect network" forever.
    rpcUrl: `https://mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_API_KEY || "a401f99315474f15bf32bb81404d0886"}`
  }
  const sepolia = {
    chainId: 11155111,
    name: 'Sepolia',
    currency: 'ETH',
    explorerUrl: 'https://sepolia.etherscan.io',
    rpcUrl: 'https://ethereum-sepolia-rpc.publicnode.com'
  }
  const metadata = {
    name: "CYPHERDUDES"
  }

  createWeb3Modal({
    ethersConfig: defaultConfig({ metadata }),
    chains: [mainnet, sepolia],
    projectId,
    themeMode: 'dark',
    themeVariables: {
      '--w3m-font-family': 'Andale Mono',
      '--w3m-font-size-master': '13px',
      '--w3m-border-radius-master': '1px',
      '--w3m-accent': '#00FF00',
    }
  })

  useEffect(() => {
    isSuperAdmin();
  }, []);

  useEffect(() => {
    isSuperAdmin();
  }, [address]);

  useEffect(() => {
    isSuperAdmin();
  }, [isConnected]);

  const isSuperAdmin = () =>{
    if(isConnected){
      if(address === superAdminAddress){
        setSuperAdmin(true);
      } else {
        setSuperAdmin(false);
      }
    }
  }

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Root />,
      errorElement: <ErrorPage />,
      children: [
        {
          index: true,
          element: <About  />,
        },
        {
          path: 'about',
          element: <About/>,
        },
        {
          path: 'collection/:paginator',
          element: <Collection  />,
        },
        {
          path: 'my_cypherdudes',
          element: <MyCypherdudes />,
        },
        {
          path: 'cypherdude/:tokenId',
          element: <Cypherdude  />,
        },
        {
          path: 'wh1t3l12t',
          element: <WhiteList  />,
        },
        {
          path: '4dm1n',
          element: <Admin auth={superAdmin}  />,
        },
        {
          path: 'leaderboard',
          element: <LeaderBoard />,
        },
        {
          path: 'archives',
          element: <Archives />,
        },
        {
          path: 'archives_collection/:paginator',
          element: <ArchivesCollection />,
        },
        {
          path: 'folder/:tokenId',
          element: <Folder />,
        },
        {
          path: 'archive/:tokenId',
          element: <Archive />,
        },
        {
          path: 'cypherdudeFS/:tokenId',
          element: <CypherdudeFS  />,
        },
        {
          path: 'cypherpalace/:palaceId',
          element: <CypherPalace  />,
        },
        {
          path: 'cyphermap',
          element: <CypherMap  />,
        },
        {
          path: 'dos/:tokenId?',
          element: <Dos />,
        },
        {
          path: 'satoshiMint',
          element: <SatoshiMint />,
        },
        {
          // TEMPORARY
          path: 'tmp',
          element: <Tmp />,
        },
        {
          path: 'bip39Cloud',
          element: <WordsCloudFullScreen  />,
        },
        {
          path: 'artefacts',
          element: <Artefacts  />,
          children : [
            {
              path: 'cypherpalaces',
              element: <CypherPalaces />,
            },
            {
              path: 'cypherpagers',
              element: <CypherPagers />,
            },
            {
              path: 'dos',
              element: <DecentralizedOS />,
            },
            {
              path: 'cypherboards',
              element: <CypherBoards />,
            },
          ]
        },
      ]
    },
    {
      path:"*",
      element: <About />,
    }

  ])

  return (
    <>
      <RouterProvider router={router} />
    </>
  )

}

export {whitelistDB, bip39, alchemySettings};
export default App;